import script from "./StarParticles.vue?vue&type=script&setup=true&lang=js"
export * from "./StarParticles.vue?vue&type=script&setup=true&lang=js"

import "./StarParticles.vue?vue&type=style&index=0&id=e5de66f6&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e5de66f6"]])

export default __exports__